import { useTranslation } from "react-i18next";

export default function InquiryForm() {
  const { t } = useTranslation();

  return (
    <section className="bg-deepblack py-20 md:py-28">
      <div className="w-full px-6 md:px-12 lg:px-16 max-w-2xl mx-auto text-center">
        <div className="bg-charcoal/20 rounded-2xl border border-white/5 p-10 md:p-16">
          <div className="w-16 h-16 rounded-full bg-champagne/10 flex items-center justify-center mx-auto mb-8">
            <i className="ri-mail-line text-champagne text-2xl" />
          </div>
          <h2 className="text-marble font-serif text-2xl md:text-3xl font-light tracking-wide mb-4">
            {t("inquiry.form.emailLabel")}
          </h2>
          <p className="text-warmgray text-sm md:text-base font-sans leading-relaxed mb-8 whitespace-pre-line text-left">
            {t("inquiry.form.emailDescription")}
          </p>
          <a
            href="mailto:contact@maisonsound.andme-grp.com"
            className="inline-flex items-center gap-2 bg-champagne/10 hover:bg-champagne/15 border border-champagne/30 rounded-full px-3 md:px-6 py-3 md:py-4 text-champagne text-xs sm:text-sm md:text-base font-sans tracking-wide transition-all duration-300 max-w-full"
          >
            <i className="ri-mail-send-line flex-shrink-0 text-sm" />
            <span className="break-all">contact@maisonsound.andme-grp.com</span>
          </a>
          <p className="text-warmgray/40 text-xs font-sans mt-6">
            {t("inquiry.form.responseTime")}
          </p>
        </div>
      </div>
    </section>
  );
}